import { v4 } from "uuid";
import { FolderTypeNames } from "../../config/permissions.config";
class TagTreeDataInfo {
  full_name: string;
  full_path: string;
  id: string;
  name: string;
  type: string;
  isNew: boolean;
  isUpdate: boolean;
  count: number;
  constructor(params?: { id?: string; name?: string; isNew?: boolean; count?: number }) {
    // const id = v4();
    this.full_name = params?.name || "";
    this.name = params?.name || "";
    this.full_path = params?.id || "";
    this.id = params?.id || v4();
    this.type = FolderTypeNames.TAGS;
    this.isNew = params?.isNew || false;
    this.isUpdate = false;
    this.count = params?.count || 0;
  }
}

export default TagTreeDataInfo;
